var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import ThemeDiff from './theme-diff';
var ThemeSync = function ThemeSync(props) {
  var _a = __read(useState(false), 2),
    visible = _a[0],
    setVisible = _a[1];
  var theme = props.theme || {};
  return theme.isMine && theme.origin && theme.extendType === 'fork' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setVisible(true);
    }
  }, props.children || '同步'), visible && /*#__PURE__*/React.createElement(ThemeDiff, {
    theme: props.theme,
    onCancel: function onCancel() {
      setVisible(false);
    }
  })) : null;
};
export default ThemeSync;